// src/utils/fontSize.js
// Global UI font-size preference (small | medium | large).
// The actual scale is applied in CSS via the `data-font-size` attribute on <html>.
const FONT_KEY = 'fontSizePref'; // cache to avoid flashes between loads

const ALLOWED = ['small', 'medium', 'large'];

export function applyFontPref(pref = 'medium') {
  const value = ALLOWED.includes(pref) ? pref : 'medium';

  // Cache for instant subsequent loads
  try { localStorage.setItem(FONT_KEY, value); } catch {}

  document.documentElement.setAttribute('data-font-size', value);
}

/** Run ASAP on app boot to avoid a size flash before profile loads */
export function initFontFromCache() {
  let cached = null;
  try { cached = localStorage.getItem(FONT_KEY); } catch {}
  applyFontPref(cached || 'medium');
}
